import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ChangeDetectionStrategy,
  TemplateRef,
  inject
} from '@angular/core';
import { CommonService } from '../../services/common.service';
import { ActionIconDef, Grid as InavistaGrid, GridActionIconClickEvent, GridConfig, GridRowCommitEvent } from '@inavista/components/grid';
import { exportInavistaGrid } from '../../utils/inavista-grid-export';
import { LocalRowsGridApi, provideLocalGridRows } from '../../utils/local-rows-grid-api';
import { buildChecklistActionIcons, buildChecklistGridConfig, CHECKLIST_COLUMNS } from './showchecklist.grid.config';
import { InvoicePopupOpenedFrom } from 'projects/service/src/app/modules/service-order/models/service-order.model';
import { forkJoin } from 'rxjs';

@Component({
    selector: 'app-showchecklist',
    templateUrl: './showchecklist.component.html',
    styleUrls: ['./showchecklist.component.scss'],
    // The Checklist grid reads this.gridData, not an endpoint.
    providers: [...provideLocalGridRows()],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ShowchecklistComponent implements OnInit {
  loading: boolean = false;
  isExpanded: boolean = false;
  @Input() customerData;
  @Input() serviceOrderData;
  @Input() company;
  @Input() serializedItemGroupDescription;
  @Input() serializedItemGroupCode;
  @Input() technicianName;

  @Input() serviceOrderId: string;
  @Input() technicianId: string;
  @Input() createdDate: string;
  @Input() createdBy: string;
  @Input() lastUpdatedDate: string;
  @Input() lastUpdatedBy: string;
  @Input() newchecklistid: string;

  @Input() hasChecklist = '';
  @Input() increment: boolean = false;
  showInvoicePopup: boolean = false;
  @Output() onClose = new EventEmitter();
  @Output() checklistId = new EventEmitter();
  @Output() certificateGenerate = new EventEmitter();

  checklistID: string;
  mydayDropdownData: any;
  gridId: string = 'gridnamestring';
  USER;
  object = {};
  checklistCertificate: boolean = false;
  saveButtonobject = {};
  @ViewChild('checklistPopupGrid') checklistPopupGrid: InavistaGrid;
  @ViewChild('statusCell', { static: true }) statusCell: TemplateRef<unknown>;
  checklistConfig: GridConfig = null;
  checklistActionIcons: ActionIconDef[] = [];
  private readonly checklistRows = inject(LocalRowsGridApi);
  checklistPopupGridId = 'checklist-popup-grid';
  disabledButton = document.querySelector('#button');
  disabledStatus: boolean = true;

  public dropDownValues = [];

  public gridData: any;

  mydayOverdueId = 'myday-grid-overdue';
  selectedItem: any;
  dropDownValue: any;
  dropdownEnabled = true;
  heading: string;
  hasChecklistReprt: boolean = false;

  commentText: HTMLInputElement;
  commentTextObject: any;
  InvoicePopupOpened: typeof InvoicePopupOpenedFrom;
  showLoader: boolean;

  constructor(
    private commonService: CommonService
  ) {
    this.USER = this.commonService.USER;
    this.InvoicePopupOpened = InvoicePopupOpenedFrom;
  }


  ngOnInit(): void {
    this.heading = 'Checklist Certificate';
    this.initChecklistGrid();

    if (this.hasChecklist) {
      this.dropdownEnabled = false;
      this.checklistID = this.hasChecklist;
      this.showLoader = true;
      forkJoin([
        this.commonService.getKingslynnChecklistForDDLTableData(this.serializedItemGroupCode),
        this.commonService.getChecklistbyId(this.hasChecklist)
      ]).subscribe((res: any) => {

        if (res[0].isSuccessful) {
          res[0].result.forEach((item: any) => {
            this.dropDownValues.push(item.checklistType);
          })
        }

        if (res[1].isSuccessful) {
          this.selectedItem = res[1].result?.items[0]?.checklistType;
          this.hasChecklistReprt = res[1].result.hasChecklistReprt;
          this.gridData = res[1].result.items;
          this.refreshChecklistGrid();

          if (res[1].result.hasChecklistReprt) {
            this.dropdownEnabled = false;
          }

          this.object = {
            company: res[1].result.company,
            checklistId: res[1].result.checklistId,
            technicianName: res[1].result.technicianName,
            serviceOrderId: res[1].result.serviceOrderId,
            technicianId: res[1].result.technicianId,
            createdDate: res[1].result.createdDate,
            createdBy: res[1].result.createdBy,
            lastUpdatedDate: res[1].result.lastUpdatedDate,
            lastUpdatedBy: res[1].result.lastUpdatedBy,
            items: res[1].result.items
          }
          this.disabledStatus = false;
        } else {
          this.commonService.showNotification('error', res.message);
        }
        this.showLoader = false;
      }, error => {
        this.commonService.showNotification('error', error.message);
        this.showLoader = false;
      });
    } else {
      this.getItemGroupDDL();
    }
  }

  expandCollapse(value: boolean) {
    this.isExpanded = value;
  }

  getItemGroupDDL() {
    this.commonService.getKingslynnChecklistForDDLTableData(this.serializedItemGroupCode).subscribe((res: any) => {
      res.result.forEach((item: any) => {
        this.dropDownValues.push(item.checklistType);
      })
    })
  }

  acceptAllClick(args: any) {
    this.gridData.forEach((res: any) => {
      res.status = 'Approved';
      // }
    })
    this.refreshChecklistGrid();
  }

  rejectAllClick(args: any) {
    this.gridData.forEach((res: any) => {
      res.status = 'Rejected';
    })
    this.refreshChecklistGrid();

  }

  // Checklist grid on @inavista/components: the rows are this.gridData, served by LocalRowsGridApi.
  initChecklistGrid() {
    this.checklistRows.columns.set(LocalRowsGridApi.schema(CHECKLIST_COLUMNS));
    this.checklistConfig = buildChecklistGridConfig({
      statusCell: this.statusCell,
      canExport: !!this.commonService.roleClaims['AllGrid_Toolbar_Excel_Export']?.visible,
    });
    this.checklistActionIcons = buildChecklistActionIcons();
  }

  // Where the old grid refreshed (or got a new dataSource): the rows as they are now.
  refreshChecklistGrid() {
    this.checklistRows.rows.set(this.gridData ?? []);
    this.checklistPopupGrid?.refresh({ keepScroll: true });
  }

  // A saved Comments edit goes back into this.gridData (the Syncfusion grid wrote into its dataSource the same way).
  onChecklistCommit(commit: GridRowCommitEvent) {
    const item = this.gridData?.find((x: any) => x.id == commit.row['id']);
    if (item && 'comment' in commit.row) item.comment = commit.row['comment'];
    this.refreshChecklistGrid();
  }

  onChecklistChange(args): void {
    if (args.isInteracted) {
      this.commonService.getKingslynnChecklistForDDL(args.value, this.serializedItemGroupCode).subscribe((res: any) => {
        this.gridData = res.result;
        this.refreshChecklistGrid();
        this.object = {
          company: this.company,
          checklistId: this.hasChecklist,
          technicianName: this.technicianName,
          serviceOrderId: this.serviceOrderId,
          technicianId: this.technicianId,
          createdDate: this.createdDate,
          createdBy: this.createdBy,
          lastUpdatedDate: this.lastUpdatedDate,
          lastUpdatedBy: this.lastUpdatedBy,
          items: this.gridData
        }

      })
    }

    const btn = document.getElementById('btn') as HTMLButtonElement | null;
    if (btn != null) {
      btn.disabled = false;
    }

    this.disabledStatus = false;
    // Fixed (Martin, 2026-10-28): leftover demo code appended a message to an #event element that does not exist, so
    // every checklist change threw after this point. Nothing read that message; removed.
  }

  getStatusClass(status: string) {
    return this.commonService.getStatusClassForChecklist(status);
  }

  generate() {
    // As endEdit did: the row open for editing is saved into gridData first.
    this.checklistPopupGrid?.saveBatch();
    if (this.hasChecklistReprt) {
      this.commonService.showConfirmation('Are you sure? Any previous checklist certificate for this Service Order will be replaced with this one.')
        .then(result => {
          if (result.isConfirmed) {
            this.saveChecklist(true, false);
          }
        });
    }
    else {
      this.saveChecklist(true, false);
    }
  }

  saveChecklist(generate?, saveAndClose?) {
    this.checklistPopupGrid?.saveBatch();
    this.showLoader = true;
    this.saveButtonobject = {
      company: this.company,
      checklistId: this.hasChecklist ? this.hasChecklist : "",
      technicianName: this.technicianName,
      serviceOrderId: this.serviceOrderId,
      technicianId: this.technicianId,
      createdDate: this.createdDate,
      createdBy: this.createdBy,
      lastUpdatedDate: this.lastUpdatedDate,
      lastUpdatedBy: this.lastUpdatedBy,
      items: this.gridData,
      generalQAC: [],
      liftQAC: [],
      brakeTesterQAC: [],
      headlampTesterQAC: [],
      commentQAC: [],
      checklistItems: ""
    }
    this.commonService.SaveChecklist(this.saveButtonobject).subscribe((res: any) => {
      this.showLoader = false;
      if (res.isSuccessful) {
        this.checklistID = res.result.checklistId;
        this.checklistId.emit(res.result.checklistId);
        this.object['checklistId'] = res.result.checklistId;
        if (generate) {
          this.checklistCertificate = true;
          this.showInvoicePopup = true;

        }
        if (saveAndClose) {
          this.close();
        }
        this.commonService.showNotification('success', res.message);
      } else {
        this.commonService.showNotification('error', res.message);
      }
    })
  }

  close() {
    this.onClose.emit(this.checklistID);
  }



  // Approve / Reject on a row: its status becomes the button's title, as before.
  onChecklistActionIconClick(event: GridActionIconClickEvent) {
    this.gridData.forEach((res: any) => {
      if (res.id == event.row['id']) {
        res.status = event.iconKey;
      }
    })
    this.refreshChecklistGrid();
  }

  onChecklistExportRequested() {
    exportInavistaGrid(this.checklistPopupGrid, 'Service Orders');
  }

  onInvoicePopupClosed() {
    this.showInvoicePopup = false;
  }
}



